import React from 'react';

import Layout from 'components/Foundation/Layout';
import SEO from 'components/Foundation/SEO';
import Container from 'components/ui/Container';
import TitleSection from 'components/ui/TitleSection';

const Community: React.FC = () => (
    <Layout>
        <SEO title="community" />
        <Container section>
        <TitleSection title="Community Members" subtitle="Under Construction" center />
        <p className="mt-4 text-center w-full">Will be available soon ...</p>
        </Container>
    </Layout>
);

export default Community;
